/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StampIcon = ({ width = 24, height = 24, hidden = false, title = 'Stamp' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M25.273 15.333a2.728 2.728 0 0 0-5.455 0v5.333a2.728 2.728 0 0 0 5.455 0Z" />
    <path
      d="M36 5.556V4h-4.686c0 2.008-.8 2.182-1.777 2.182S27.759 6.008 27.759 4h-4.1c0 2.008-.8 2.182-1.778 2.182S20.105 6.008 20.105 4h-4.137c0 2.008-.8 2.182-1.778 2.182S12.413 6.008 12.413 4H8.16c0 2.008-.8 2.182-1.778 2.182S4.6 6.008 4.6 4H0v1.556c2.008 0 2.182.8 2.182 1.778S2.008 9.111 0 9.111v3.556c2.008 0 2.182.8 2.182 1.778S2.008 16.222 0 16.222v3.556c2.008 0 2.182.8 2.182 1.778S2.008 23.333 0 23.333v3.556c2.008 0 2.182.8 2.182 1.778S2.008 30.444 0 30.444V32h4.585c0-2.008.8-2.182 1.778-2.182s1.778.174 1.778 2.182h4.212c0-2.008.8-2.182 1.777-2.182s1.778.173 1.778 2.182H20.2c0-2.008.8-2.182 1.778-2.182s1.778.173 1.778 2.182h3.884c0-2.008.8-2.182 1.778-2.182S31.2 29.992 31.2 32H36v-1.556c-2.008 0-1.818-.8-1.818-1.778s-.19-1.778 1.818-1.778v-3.555c-2.008 0-2.182-.8-2.182-1.778s.173-1.778 2.182-1.778v-3.555c-2.008 0-2.182-.8-2.182-1.778s.173-1.778 2.182-1.778V9.111c-2.008 0-2.182-.8-2.182-1.778S33.992 5.556 36 5.556Zm-19.818 9.777a6.365 6.365 0 0 1 12.728 0v5.333a6.365 6.365 0 0 1-12.728 0ZM7.091 9.111h5.455v17.778H8.909V12.667H7.091Z"
    />
  </svg>`;
};
